import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../_services/session/session.service';

@Component({
    selector: 'navigate-session-id',
    templateUrl: './navigate-session-id.component.html',
    styleUrls: ['./navigate-session-id.component.scss'],
    providers: [TranslatePipe],
})
export class NavigateSessionIdComponent implements OnInit {
    sessionSearchError: string = '';
    searchSession: string = '';

    constructor(private sessionService: SessionService) {}

    ngOnInit(): void {}

    onKeyPress($event) {
        this.sessionSearchError = '';
        if ($event.keyCode == 13) {
            let searchSession = this.searchSession;
            if (searchSession.length == 0) {
                this.sessionSearchError = 'Session inconnue';
                return;
            }

            if (searchSession[0] == 'F') {
                searchSession = searchSession.substr(1);
            }
            searchSession = searchSession.split('-')[0];

            this.sessionService.findOne(searchSession).subscribe(
                () => {
                    window.location.href = '#/session/' + searchSession;
                },
                () => {
                    this.sessionSearchError = 'Session inconnue';
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/navigate-session-id/navigate-session-id.component.ts